import { render } from "./ResetPassForm.vue?vue&type=template&id=2344a69d&scoped=true&lang=true"
import script from "./ResetPassForm.vue?vue&type=script&lang=js"
export * from "./ResetPassForm.vue?vue&type=script&lang=js"

import "./ResetPassForm.vue?vue&type=style&index=0&id=2344a69d&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2344a69d"]])

export default __exports__